import React from 'react'
import { useLocalization } from '@/hooks/localization'
import * as PopoverOrig from 'antd/lib/popover'

function getPopupContainer () {
  return document.querySelector('.main__body')
}

export const Popover = React.memo(function Popover ({ children, ...props }) {
  const { rtl } = useLocalization()

  return <PopoverOrig placement={rtl ? 'left' : 'right'} getPopupContainer={getPopupContainer} mouseEnterDelay={0.1} mouseLeaveDelay={0.1} {...props}>
    {children}
  </PopoverOrig>
})



// WEBPACK FOOTER //
// ./src/components/popover.js